<template>
    <div class="property-info">
        <span v-if="preText"
              class="property-info__intro">{{ preText }}</span>
        <span :class="`property-info__address${this.showChangeLink ? ' --with-link' : ''}`">
            {{ property ? property.asString() : 'No property selected' }}
        </span><router-link v-if="showChangeLink"
                            :to="{ name: 'MyHome', query: { id: property.id || 0 } }"
                            class="property-info__change">
            anything look wrong?
        </router-link>
    </div>
</template>

<script>

export default {

    props: {
        property: {
            type: Object,
            default: null,
        },
        preText: {
            type: String,
            default: null,
        },
        showChangeLink: {
            type: Boolean,
            default: false,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_property-info.scss

.property-info {
    font-weight: bold;

    @include element('intro') {

        &:after {
            content: ' '
        }
    }

    @include element('address') {

        &.--with-link {
            &:after {
                content: ' - '
            }
        }
    }

    @include element('change') {
        font-weight: normal;
    }
}

</style>
